<template>
  <router-view />
</template>

<script setup lang="ts">
import { useQuasar } from 'quasar';
import { useFarmStore } from '@/store/modules/farm';
import { useJwtStore } from '@/store/modules/jwt';
import { useMapStore } from '@/store/modules/map';
import { bus } from '@/utils/event-bus';

const $q = useQuasar();
const farmStore = useFarmStore();
const jwtStore = useJwtStore();
const mapStore = useMapStore();

mapStore.getGeoserverConfig();
bus.on('subscribe', data => {
  if (!data.user_agent) {
    data.user_agent = window.navigator.userAgent;
  }
  jwtStore.subscribe(data);
});

(async () => {
  await jwtStore.refreshAccessToken();
  if (jwtStore.isLoggedIn) {
    await farmStore.getMyDefaultFarm();
  } else {
    await farmStore.setFetchingDefaultFarm(false);
  }
  $q.dark.set(!!import.meta.env.VUE_APP_DARK_MODE);
})();
</script>

<style lang="sass">
.ol-control
  background-color: white !important
  // OL 6 (Vue 2 build, still running on test server) had a default
  // `padding: 2px` on .ol-control; OL 9 dropped it. Restore so the
  // toolbar panels keep their original visual spacing.
  padding: 2px
  button
    background-color: $primary !important
    // OL 9 ships color: var(--ol-subtle-foreground-color) (=#666) for
    // .ol-control button. With our $primary blue background, Material Icon
    // (q-icon) characters and built-in Zoom +/− glyphs need white to read.
    // <img>/svg-icon buttons paint their own fill so they look fine
    // either way; this rule fixes the font-icon ones.
    color: white !important
    &:hover, &:focus
      color: white !important

// Map / SwipeMap / SideBySideMap all instantiate `new ScaleLine({ className:
// 'scale-line ol-scale-line' })` and paint the bar $primary. OL's default
// .ol-scale-line-inner inherits color: #333 and a dark grey border; against
// our blue background those need white.
.ol-scale-line-inner
  color: white !important
  border-color: white !important

.ol-control--dark
  background: $dark !important

.q-table--dark
  tr th
    background: $dark !important
  tr td
    background: $dark !important
.table--max-height
  max-height: calc(100vh - 230px)
  thead tr th,   thead tr td
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #fff

  thead tr td
    font-weight: 500
    font-size: 12px

  $n: 10
  @for $i from 1 through $n
    thead tr:nth-child(#{$i}) td,
    thead tr:nth-child(#{$i}) th
      top: 48px * ($i - 1)
</style>
